import { SubcategoriesStaticData } from "data/categories";
import WarrantySecondHand from "components/product/reassurance/assets/warranty_reco.svg";
import WarrantyNew from "components/product/reassurance/assets/warranty_new.svg";
import Repair from "components/product/reassurance/assets/repair_2.svg";
import Green from "components/product/reassurance/assets/green_2.svg";
import { getProductEligibility } from "components/localOfferEligibility/LocalOfferEligibility";
import LocalOfferPicto from "components/product/reassurance/assets/local_2.svg";

export const getThumbnail = (image, width) => {
  if (image.startsWith("https://res.cloudinary.com/")) {
    return image.replace("image/upload/", `image/upload/c_fill,w_${width}/`);
  }
  return image;
};

export const formatPrice = (price) => {
  const priceUnits = price / 100.0;
  if (isNaN(priceUnits)) {
    return "";
  }

  const digits = price % 100 > 0 ? 2 : 0;
  return priceUnits.toFixed(digits).replace(".", ",") + "€";
};

export const formatPriceRound = (price) => {
  const priceUnits = price / 100.0;
  if (isNaN(priceUnits)) {
    return "";
  }

  return `${Math.round(priceUnits)}€`;
};

export const formatPriceCents = (price) => {
  const priceUnits = price / 100.0;
  if (isNaN(priceUnits)) {
    return "";
  }

  return priceUnits.toFixed(2).replace(".", ",") + "€";
};

export const lowerSubcategory = (subcategory) => {
  return (subcategory || "").toLowerCase();
};

export const getModelName = (product) => {
  return [product.brand, product.model_reference, product.subcategory1, lowerSubcategory(product.subcategory2)]
    .filter((x) => x)
    .join(" ");
};

export const getModelType = (product) => {
  if (product.categories && product.categories.length > 0) {
    return SubcategoriesStaticData.find((cat) => cat.slug === product.categories[0])?.name;
  }
  return [product.product_type, lowerSubcategory(product.subcategory1), lowerSubcategory(product.subcategory2)]
    .filter((x) => x)
    .join(" ");
};

export const getModelCategory = (product) => {
  if (product.category1) {
    return product.category1
      .map((category) => SubcategoriesStaticData.find((cat) => cat.slug === category)?.name)
      .join(" - ");
  }
  return [product.subcategory1, lowerSubcategory(product.subcategory2)].filter((x) => x).join(" ");
};

export const newState = "neuf";
export const isProductNew = (product) => {
  return product.appearance === newState || product.appearance_slug === newState;
};

export const reinsuranceContent = (product) => {
  const isLocal = getProductEligibility(product);
  const isNew = isProductNew(product);

  const contentMap = {
    localNew: [
      { label: "Livraison 48h", picto: LocalOfferPicto() },
      { label: "Click & Collect gratuit", picto: LocalOfferPicto() },
      { label: "Sélectionné par nos réparateurs", picto: Repair() },
      { label: "Garantie 2 ans", picto: WarrantyNew() },
    ],
    localRefurbished: [
      { label: "Livraison 48h", picto: LocalOfferPicto() },
      { label: "Click & Collect gratuit", picto: LocalOfferPicto() },
      { label: "Réparé et testé en France", picto: Green() },
      { label: "Garantie 2 ans", picto: WarrantySecondHand() },
    ],
    new: [
      { label: "Sélectionné par nos réparateurs", picto: Repair() },
      { label: "Excellente réparabilité", picto: Green() },
      { label: "Garantie 2 ans", picto: WarrantyNew() },
    ],
    refurbished: [
      { label: "Réparé et testé en France", picto: Repair() },
      { label: "100% fonctionnel", picto: Green() },
      { label: "Garantie 2 ans", picto: WarrantySecondHand() },
    ],
  };

  if (isLocal) {
    return isNew ? contentMap.localNew : contentMap.localRefurbished;
  }

  return isNew ? contentMap.new : contentMap.refurbished;
};

export const buildWarrantyContent = () => {
  return { label: "Garantie 2 ans", picto: WarrantySecondHand() };
};
